enum RelayConnection {
  CampaignPosts = "CampaignPosts",
  EditionsForMasterEditionMint = "EditionsForMasterEditionMint",
  NftTransactions = "NftTransactions",
}

export default RelayConnection;
